// extracted by mini-css-extract-plugin
export default {"logo":"header-logo_logo__+cT-4","logoImg":"header-logo_logoImg__lEVtv"};